import React, { HTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

export const MediaButtonContainer: React.FC<
  React.PropsWithChildren<HTMLAttributes<HTMLDivElement>>
> = ({ children, className, ...props }) => (
  <div
    className={twMerge('absolute bottom-4 left-4 z-10', className)}
    {...props}
  >
    {children}
  </div>
)
